import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=c6bb4896&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=c6bb4896&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6bb4896",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6bb4896')) {
      api.createRecord('c6bb4896', component.options)
    } else {
      api.reload('c6bb4896', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=c6bb4896&scoped=true&", function () {
      api.rerender('c6bb4896', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2JjtwS3KZjfzi/JS/comp/PopupBox.vue"
export default component.exports